module.exports = __webpack_public_path__ + "img/table-minus.c992b30c.svg";